/* نبض حضور — للوحة المدير والبث الحي */
import { S, api, on } from './core.js';

let timer = null;

export function pingPresence() {
  if (!S.user) return;
  const view = document.body.dataset.view || 'agents';
  const n = Number(window.__omdaaAgentsRunning || 0);
  void api('/me/presence', {
    method: 'POST',
    body: { view, agentRunning: n > 0 },
  }).catch(() => {});
}

export function startPresenceHeartbeat() {
  if (timer) return;
  pingPresence();
  timer = setInterval(pingPresence, 45000);
  on('show', () => pingPresence());
}

export function stopPresenceHeartbeat() {
  if (timer) clearInterval(timer);
  timer = null;
}
